"use client";
import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";

interface HeaderProps {
  selectedTab: string;
  onTabChange: (tab: string) => void;
}

const goToChatSubdomain = () => {
  const { hostname, protocol, port } = window.location;
  const baseHost = hostname.replace(/^chat\./, '');
  const chatHost = `chat.${baseHost}`;
  const fullURL = `${protocol}//${chatHost}${port ? `:${port}` : ''}`;
  window.location.href = fullURL;
};

const Header: React.FC<HeaderProps> = ({ selectedTab, onTabChange }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleKeyPress = (event: React.KeyboardEvent, action: () => void) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      action();
    }
  };

  const goHome = () => {
    if (location.pathname !== "/") {
      navigate("/");
    }
  };

  const goToFeatures = () => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: "features" } });
    } else {
      const el = document.getElementById("features-panel");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
    onTabChange("features");
  };

  return (
    <header className="flex fixed top-4 justify-center w-full z-[1001]" dir="rtl">
      <nav className="flex gap-4 items-center px-4 py-2 border border-solid backdrop-blur-lg backdrop-saturate-[1.8] bg-black bg-opacity-40 border-zinc-800 rounded-[48px]">
        <img
          alt="لوگوی پلتفرم هوش مصنوعی"
          src="/logo512.png"
          className="object-cover overflow-hidden w-8 h-8 aspect-square cursor-pointer"
          onClick={goHome}
        />
        <div role="tablist" aria-label="ناوبری اصلی" className="flex gap-3">
          <button
            className="px-3 py-1.5 text-sm rounded-lg transition-all cursor-pointer border-[none] duration-[0.2s]"
            role="tab"
            aria-controls="features-panel"
            id="features-tab"
            aria-selected={selectedTab === "features"}
            tabIndex={0}
            onKeyDown={(event) => handleKeyPress(event, goToFeatures)}
            onClick={goToFeatures}
            style={{
              color: selectedTab === "features" ? "#fff" : "#aaa",
            }}
          >
            قابلیت‌ها
          </button>
        </div>
        <button
          className="px-4 py-1.5 text-sm font-medium text-black bg-white transition-all cursor-pointer border-[none] duration-[0.2s] rounded-[32px]"
          aria-label="شروع کنید"
          onKeyDown={(event) => handleKeyPress(event, goToChatSubdomain)}
          onClick={goToChatSubdomain}
        >
          شروع کنید
        </button>
      </nav>
    </header>
  );
};

export default Header;
